import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Shield, Award, Users, Ruler, ArrowRight } from "lucide-react";
import axios from "axios";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

const API = process.env.REACT_APP_BACKEND_URL;

export default function KurumsalPage() {
  const [about, setAbout] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get(`${API}/api/about`).then((r) => setAbout(r.data)).catch(() => {});
  }, []);

  if (!about) return null;

  const stats = [
    { icon: Shield, value: about.stat_years, label: "Yıllık Deneyim" },
    { icon: Award, value: about.stat_projects, label: "Tamamlanan Proje" },
    { icon: Users, value: about.stat_clients, label: "Mutlu Müşteri" },
    { icon: Ruler, value: about.stat_area, label: "m² İnşaat Alanı" },
  ];

  return (
    <div className="min-h-screen bg-white" data-testid="kurumsal-page">
      <Navbar />
      {/* Hero */}
      <div className="pt-20 bg-gradient-to-b from-[#0C0C0C] to-[#1a1a2e] text-white">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 sm:py-28">
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="overline justify-start mb-5 text-white/60">Hakkımızda</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-tight mb-6" style={{ fontFamily: "Outfit" }}>
            {about.title.split(" ").slice(0, 2).join(" ")} <br />
            <span className="text-[#FF5A00]">{about.title.split(" ").slice(2).join(" ")}</span>
          </motion.h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div>
            <p className="text-gray-600 leading-relaxed text-lg mb-6">{about.text}</p>
            <p className="text-gray-600 leading-relaxed text-lg mb-8">{about.text2}</p>
            <div className="flex flex-wrap gap-3">
              <button onClick={() => navigate("/hakkimizda/misyon")} className="btn-modern btn-filled text-sm">Misyonumuz <ArrowRight size={14} /></button>
              <button onClick={() => navigate("/hakkimizda/vizyon")} className="btn-modern btn-outline text-sm border-[#0C0C0C] text-[#0C0C0C] hover:bg-[#0C0C0C] hover:text-white">Vizyonumuz <ArrowRight size={14} /></button>
            </div>
          </div>
          {about.image && (
            <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img src={about.image} alt="Kurumsal" className="w-full h-[400px] lg:h-[500px] object-cover" loading="lazy" />
              </div>
              <div className="absolute -bottom-6 -left-4 sm:left-6 bg-[#FF5A00] text-white rounded-2xl p-5 shadow-lg">
                <p className="text-3xl font-bold" style={{ fontFamily: "Outfit" }}>{about.stat_years}</p>
                <p className="text-sm text-white/80">Yıllık Deneyim</p>
              </div>
            </motion.div>
          )}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-24">
          {stats.map((s, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="bg-[#F9FAFB] rounded-2xl p-6 text-center border border-gray-100">
              <s.icon size={22} className="mx-auto mb-3 text-[#FF5A00]" strokeWidth={1.5} />
              <p className="text-3xl font-bold tracking-tight text-[#0C0C0C]" style={{ fontFamily: "Outfit" }}>{s.value}</p>
              <p className="text-sm text-gray-500 mt-2 font-medium">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
